import React, { useState } from 'react';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const SearchIcon: React.FC = () => (
  <svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true" focusable="false">
    <circle cx="9" cy="9" r="5.5" fill="none" stroke="currentColor" strokeWidth="2" />
    <line x1="13" y1="13" x2="18" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const ScoringSearchBox: React.FC<Props> = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);

  function close(): void {
    onChange('');
    setOpen(false);
  }

  if (!open) {
    return (
      <button
        type="button"
        className="scoring-search__toggle"
        data-testid="scoring-search-toggle"
        aria-label="Szukaj meczu"
        onClick={() => setOpen(true)}
      >
        <SearchIcon />
      </button>
    );
  }

  return (
    <div className="scoring-search" data-testid="scoring-search">
      <span className="scoring-search__icon">
        <SearchIcon />
      </span>
      <input
        type="search"
        className="scoring-search__input"
        data-testid="scoring-search-input"
        placeholder="Szukaj zawodnika…"
        aria-label="Szukaj zawodnika"
        autoFocus
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Escape') {
            close();
          }
        }}
      />
      <button
        type="button"
        className="scoring-search__clear"
        data-testid="scoring-search-clear"
        aria-label="Zamknij wyszukiwanie"
        onClick={close}
      >
        ✕
      </button>
    </div>
  );
};

export default ScoringSearchBox;
